/*
 *  Copyright IBM Corp. 2025, 2026
 *
 *  This source code is licensed under the Apache-2.0 license found in the
 *  LICENSE file in the root directory of this source tree.
 *
 *  @license
 */

import cx from "classnames";
import Processing from "@carbon/ai-chat-components/es-custom/react/processing.js";
import React from "react";
import { AriaLiveMessage } from "../components/aria/AriaLiveMessage";
import { CarbonTheme } from "../../types/config/PublicConfig";

interface MessagesTypingIndicatorProps {
  carbonTheme: CarbonTheme;
  index: number;
  isTypingMessage?: string;
  isVisible: boolean;
  processingLabel: string;
  statusMessage?: string;
}

function MessagesTypingIndicator({
  carbonTheme,
  index,
  isTypingMessage,
  isVisible,
  processingLabel,
  statusMessage,
}: MessagesTypingIndicatorProps) {
  return (
    <div
      className={cx(
        `cds-custom-aichat--message cds-custom-aichat--message-${index} cds-custom-aichat--message--last-message`,
        { "cds-custom-aichat--typing-indicator--hidden": !isVisible },
      )}
    >
      <div className="cds-custom-aichat--message--padding">
        {isVisible && isTypingMessage && (
          <AriaLiveMessage message={isTypingMessage} />
        )}
        <div className="cds-custom-aichat--assistant-message">
          <div className="cds-custom-aichat--received cds-custom-aichat--received--loading cds-custom-aichat--message-vertical-padding">
            <div className="cds-custom-aichat--received--inner">
              <div className="cds-custom-aichat--processing">
                <Processing
                  className="cds-custom-aichat--processing-component"
                  loop
                  quickLoad
                  carbonTheme={carbonTheme}
                  aria-label={processingLabel}
                />{" "}
                <div className="cds-custom-aichat--processing-label">
                  {statusMessage}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { MessagesTypingIndicator };
